import baseAPI from '@/api';
import { AxiosResponse } from 'axios';
import { CanCreateRollCompetitionEntryResponseDto } from '@/services/dto/roll-competition-entries/can-create-roll-competition-entry-response.dto';

export async function fetchRollCompetitionEntriesValidate(): Promise<CanCreateRollCompetitionEntryResponseDto> {
  const response: AxiosResponse<CanCreateRollCompetitionEntryResponseDto> =
    await baseAPI.get<CanCreateRollCompetitionEntryResponseDto>(
      `/roll-competition-entries/validate`,
    );

  return response.data;
}
